import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

const getIconColor = (props) => {
    switch (props.color) {
        case 'darkGray':
            return props.theme.black;
        case 'mediumGray':
            return props.theme.grey_72_lc;
        case 'lightGray':
            return props.theme.grey_40_lc;
        case 'superLightGray':
            return props.theme.grey_8_lc;
        case 'greyRgba28':
            return props.theme.grey_28_tr;
        case 'purple':
            return props.theme.purple_100;
        case 'purpleRgba24':
            return props.theme.purple_24_tr;
        case 'purpleRgba40':
            return props.theme.purple_40_tr;
        case 'red':
            return props.theme.pink_100;
        case 'white':
            return props.theme.white;
        case 'white_base':
            return props.theme.white_base;
        default:
            return props.theme.black;
    }
};

const defaultSize = '24px';

const Container = styled.span`
    display: inline-block;
    height: ${(props) => (props.size ? props.size : defaultSize)};
    margin-right: ${(props) => (props.rightIndent ? props.rightIndent : null)};
    margin-left: ${(props) => (props.leftIndent ? props.leftIndent : null)};

    svg {
        width: ${(props) => (props.size ? props.size : defaultSize)};
        height: ${(props) => (props.size ? props.size : defaultSize)};
        --accent: ${(props) => getIconColor(props)};
    }
`;

function renderSVG({ id }) {
    return (
        <svg>
            <use xlinkHref={`/i/svg-icons/icons.svg#${id}`} />
        </svg>
    );
}

const StyledSVGIcon = styled(renderSVG)`
    display: inline-block;
`;

export const Icon = (props) => {
    return (
        <Container rightIndent={props.rightIndent} leftIndent={props.leftIndent} color={props.color} size={props.size}>
            <StyledSVGIcon id={props.name} />
        </Container>
    );
};

Icon.propTypes = {
    name: PropTypes.string,
    color: PropTypes.oneOf([
        'darkGray',
        'mediumGray',
        'lightGray',
        'superLightGray',
        'greyRgba28',
        'purple',
        'purpleRgba24',
        'purpleRgba40',
        'red',
        'white',
        'white_base',
    ]),
    size: PropTypes.oneOf(['16px', '20px', '24px', '32px', '48px', '56px', '64px', '80px', '96px', '100%']),
    rightIndent: PropTypes.oneOf(['4px', '8px', '12px', '16px', '24px', '32px']),
    leftIndent: PropTypes.oneOf(['2px', '4px', '8px', '12px', '16px', '24px', '32px']),
};
